



















































































































































































































































































































































































































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {namespace} from "vuex-class";
import IClose from '@/components/icons/IClose.vue'

const locale = namespace('locale')

@Component({
  components: {
    'i-close': IClose,
  }
})
export default class UserAgreement extends Vue {
  @locale.Getter('getLocale') protected getLocale:any

  @Prop({type: Boolean, default: false}) protected modalShow!: boolean

  region:string | null = ''

  @Watch('modalShow')
  setRegion() {
    this.region = localStorage.getItem('region')
  }

  mounted() {
    this.region = localStorage.getItem('region')
  }

  closeDialog() {
    this.$emit('close')
  }

}
